/**
 * 请求队列
 */
var RequestQueue = /** @class */ (function () {
    function RequestQueue() {
        this._loading = false;
        this._queue = {};
        this._eventEmitter = {
            loading: [],
            ending: [],
        };
    }
    /**
     * 注册loading事件
     * @param {('loading' | 'ending')} key
     * @param {function} fn 回调函数
     */
    RequestQueue.prototype.on = function (key, fn) {
        this._eventEmitter[key].push(fn);
    };
    /**
     * 增加
     * @param {*} key
     * @param {*} config
     */
    RequestQueue.prototype.add = function (key, config) {
        this._queue[key] = config;
        this.notify();
    };
    RequestQueue.prototype.remove = function (key) {
        delete this._queue[key];
        this.notify();
    };
    RequestQueue.prototype.count = function () {
        return Object.keys(this._queue).length;
    };
    RequestQueue.prototype.get = function (key) {
        return this._queue[key];
    };
    RequestQueue.prototype.filter = function (key) {
        var _this_1 = this;
        return Object.keys(this._queue)
            .filter(function (keyName) { return keyName === key; })
            .map(function (keyName) { return _this_1._queue[keyName]; });
    };
    RequestQueue.prototype.notify = function () {
        var keys = Object.keys(this._queue);
        var _this = this;
        var count = keys.filter(function (name) {
            return _this._queue[name].loading;
        }).length;
        if (count && !this._loading) {
            this._loading = true;
            this._eventEmitter.loading.forEach(function (fn) {
                fn();
            });
        }
        if (!count && !keys.length) {
            this._loading = false;
            this._eventEmitter.ending.forEach(function (fn) {
                fn();
            });
        }
    };
    return RequestQueue;
}());
export default RequestQueue;



//////////////////
// WEBPACK FOOTER
// ../emp-helpers/dist/es/request/RequestQueue.js
// module id = null
// module chunks = 